<h2 matDialogTitle>
  <mat-icon class="rds-c-filter-dialog-header-icon">filter_list</mat-icon>
  {{ data?.variable?.label || data?.variable?.name || data.variable?.id }}
</h2>

<mat-divider class="rds-c-filter-dialog-scroll-container-divider"></mat-divider>

<mat-dialog-content>
  <h3 class="rds-c-filter-dialog-subtitle" i18n>Null Filter</h3>
  <p class="mat-caption rds-c-filter-dialog-sub-text" i18n>Specifically include or exclude <em>Empty/SysMiss/Null</em> values</p>
  <rds-c-null-filter [(ngModel)]="nullFilter" (ngModelChange)="determineApplyButtonDisableState()"></rds-c-null-filter>

  <ng-container *ngIf="!!filterType">
    <mat-divider></mat-divider>
    <div class="rds-c-filter-dialog-subtitle" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
      <h3 fxFlex>{{ data?.variable | rdsFilterTypeSubtitle | uppercase }}</h3>
      <mat-slide-toggle
        *ngIf="filterType === 'CODE'"
        i18n
        class="mat-body-1"
        labelPosition="before"
        [checked]="excludeSelected$ | async"
        (change)="handleExcludeSelected($event)"
        >Exclude Selected</mat-slide-toggle
      >
    </div>
  </ng-container>

  <ng-container [ngSwitch]="filterType">
    <rds-c-code-select
      *ngSwitchCase="'CODE'"
      [ariaLabel]="data.variable?.label || data.variable?.name || data.variable?.id"
      [codes]="codes"
      [codeListStyles]="data.contentStyles"
      [enablePagination]="!hasFewCodes"
      [enableSearch]="!hasFewCodes"
      [enableSort]="!hasFewCodes"
      [loading]="loadingCodes"
      [length]="foundCodes"
      [pageIndex]="codeOffset / codePageSize"
      [pageSize]="codePageSize"
      [selectedCodes]="selectedCodes$ | async"
      [selectionType]="data.multiSelect ? 'multi' : 'single'"
      [sortDirection]="sortDirection$ | async"
      (clearSelectedCodes)="handleClearCodeFilters()"
      (search)="handleCodeSearch($event)"
      (selectCode)="handleAddCodeFilter($event)"
      (unselectCode)="handleRemoveCodeFilter($event)"
      (sortCodes)="handleCodeSort($event)"
      (pageChange)="handleCodePageChange($event)"
    ></rds-c-code-select>
    <rds-c-text-filter
      *ngSwitchCase="'TEXT'"
      [filters]="textFilters$ | async"
      [largeChips]="data.largeChips"
      [ngStyle]="data.contentStyles"
      [supportedOperators]="data.supportedFilters"
      (add)="handleAddTextFilter($event)"
      (remove)="handleRemoveTextFilter($event)"
    ></rds-c-text-filter>
    <rds-c-numeric-filter
      *ngSwitchCase="'NUMERIC'"
      [filters]="numericFilters$ | async"
      [largeChips]="data.largeChips"
      [ngStyle]="data.contentStyles"
      [supportedOperators]="data.supportedFilters"
      (add)="handleAddNumericFilter($event)"
      (remove)="handleRemoveNumericFilter($event)"
    ></rds-c-numeric-filter>
    <rds-c-date-filter
      *ngSwitchCase="'DATE'"
      [filters]="dateFilters$ | async"
      [largeChips]="data.largeChips"
      [ngStyle]="data.contentStyles"
      [supportedOperators]="data.supportedFilters"
      (add)="handleAddDateFilter($event)"
      (remove)="handleRemoveDateFilter($event)"
    ></rds-c-date-filter>
  </ng-container>
</mat-dialog-content>

<mat-divider class="rds-c-filter-dialog-scroll-container-divider"></mat-divider>

<mat-dialog-actions align="end">
  <button mat-button type="button" matDialogClose i18n>CANCEL</button>

  <button mat-raised-button color="primary" [disabled]="disableApply$ | async" (click)="handleApplyFilter()" i18n>APPLY FILTER</button>
</mat-dialog-actions>
